// The Badgermeter SDI reading is a 12-bit pulse count. This pulse count is converted to a volume reading (in US gallons) using the ConversionFormulaScale parameter.
// The volume is then converted to cubic meters and a volume rate reading is then created in cubic meters per second.
// Convert the 12 - bit value($rdg in code below) to volume($vol in code below) and then to volume rate($rate) using the following algorithm:

/*
$vol = 0.0;
if ( $rdg == 0xFFF ) {
  $vol = null; // display reading as “invalid”
} else {
  $kfactor = (float)$ConversionFormulaScale;
  $vol = ($rdg * $kfactor); // volume in US gallons

  if ( $vol > 0.0 )
  {
    // convert US gallons to cubic meters
    $vol = $this->ConvertDispToBase($vol);
  }
}

$rate = 0.0;

if ( $rdg == 0xFFF ) {
  $rate = null;
} else {
// schedule frequency is in minutes
  $sts = $this->GetStatusFlags();
  if (((int)$sts) & 0x04) {
    $sf = 1; // this is an INIT reading taken every 1 minute
  } else {
    $sf = $this->GetScheduleFrequency();
  }

  if ( $sf > 0 ) {
    $rate = $vol / ($sf * 60.0);
  }
}
*/

export function badgermeter(
  reading: number,
  scale: number,
  offset: number,
  frequency: number // special case
): number {
  const kfactor = scale
  var volume = reading * kfactor // volume in US gallons

  if (volume > 0.0) {
    // convert US gallons to cubic meters
    // volume = $this->ConvertDispToBase(volume);
    // TODO: implement convert display --> CONVERSION SHOULD HAPPEN OUTSIDE (all conversions goes to a specific base unit, conversion happen outside)
  }

  // const frequency = device.config.flagBatteryReadingEnabledInSnts
  //   ? 1
  //   : device.config.schdFrequency

  return frequency > 0 ? volume * (frequency * 60.0) : -1 // frequency is the frequency in minutes (if you look at the original code), so from time to time, the frequency changes.  it depends on the messages that are being processed
}
